import React from 'react';
import './Header.scss';
import links from 'platform/constants/links.js'

function Header() {

    return <>
        <div className="header">
            {links.headerLogoUrl && <div className="logo">
                <a href={links.headerLogoUrl}>&nbsp;</a>
            </div>}
            <div className="supportedby">
                <div className="image"></div>
            </div>
        </div>
    </>;
}

export default Header;